import Vue from 'vue'
import { Api } from '@/utility/constants'

/* store/modules/app */
const state = {
    navigationDrawer: true,
    recaptchaPublicKey: null,
    user: {
        displayName: null,
        roles: [],
        userId: 0
    },
    userSettings: {
        darkMode: false,
        stickySidebar: false
    }
}

const mutations = {
    SET_DARK_MODE(state, data) {
        state.userSettings.darkMode = data
    },

    SET_NAVIGATION_DRAWER(state) {
        state.navigationDrawer = !state.navigationDrawer
    },

    SET_RECAPTCHA_PUBLIC_KEY(state, data) {
        state.recaptchaPublicKey = data
    },

    SET_STICKY_SIDEBAR(state, data) {
        state.userSettings.stickySidebar = data
    },

    SET_USER(state, data) {
        state.user = data
    },

    SET_USER_SETTINGS(state, data) {
        state.userSettings = Object.assign({}, state.userSettings, data)
    }
}

const actions = {
    setDarkMode: ({ commit }, value) => {
        commit('SET_DARK_MODE', value)
    },

    setNavigationDrawer: ({ commit }) => {
        commit('SET_NAVIGATION_DRAWER')
    },

    setRecaptchaPublicKey: ({ commit }, value) => {
        commit('SET_RECAPTCHA_PUBLIC_KEY', value)
    },

    setStickySidebar: ({ commit }, value) => {
        commit('SET_STICKY_SIDEBAR', value)
    },

    fetchUser: async ({ commit, getters }) => {
        if (getters.getUserId === 0) {
            try {
                let response = await Vue.prototype.$http({
                    url: Api.API.GET_APP_DATA,
                    method: Api.METHOD.POST
                })

                let resp = response.data

                if (resp.success) {
                    commit('SET_USER', resp.data.user)
                    commit('SET_RECAPTCHA_PUBLIC_KEY', resp.data.recaptchaPublicKey)

                    let userSettings = Vue.$cookies.get("MyMaxCareRxUserSettings")

                    if (userSettings !== null) {
                        commit("SET_USER_SETTINGS", userSettings)
                    }
                } else {
                    return false
                }
            } catch (error) {
                return false
            }
        }

        return true
    },

    setUser: ({ commit }, value) => {
        commit('SET_USER', value)
    },

    setUserSettings: ({ commit }, value) => {
        commit('SET_USER_SETTINGS', value)
    }
}

const getters = {
    getDarkMode: () => {
        return state.userSettings.darkMode
    },

    getDisplayName: state => {
        return state.user.displayName
    },

    getNavigationDrawer: state => {
        return state.navigationDrawer
    },

    getRecaptchaPublicKey: state => {
        return state.recaptchaPublicKey
    },

    getStickySidebar: state => {
        return state.userSettings.stickySidebar
    },

    getUserId: state => {
        return state.user.userId
    },

    getUserRoles: state => {
        return state.user.roles
    },

    getUserSettings: state => {
        return state.userSettings
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}